export const plan401kDetailsInitialize = {
  planAssumptions: {
    companyName: "",
    rollover: "",
    annualContribution: "",
    annualPlanGrowth: "",
  },
  fees: {
    acrylic: {
      annualFeesPaidByBusiness: {
        numberOfEmployees: "",
        setUpFee: "",
        conversionFee: "",
        adminFee: "",
        perParticipationAnnualFee: "",
        otherFee: "",
        additionalOtherFees: [],
        totalAnnualFeesPaidByBusiness: "",
      },
      annualFeesPaidByPlanAssets: {
        acrylicAndAdvisorFee: "",
        otherAssetsBasedFee: "",
        averageMutualFundExpense: "",
        recordKeeperAssetFee: "",
        totalAannualFeesPaidByPlanAssets: "",
      },
    },
    otherCompany: {
      annualFeesPaidByBusiness: {
        numberOfEmployees: "",
        setUpFee: "",
        conversionFee: "",
        adminFee: "",
        perParticipationAnnualFee: "",
        otherFee: "",
        additionalOtherFees: [],
        totalAnnualFeesPaidByBusiness: "",
      },
      annualFeesPaidByPlanAssets: {
        acrylicAndAdvisorFee: "",
        otherAssetsBasedFee: "",
        averageMutualFundExpense: "",
        recordKeeperAssetFee: "",
        totalAannualFeesPaidByPlanAssets: "",
      },
    },
  },
  feesOnBalance: {
    year: [],
  },
};
